var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "profile-type" }, [
      _vm.profile.billing_type == "pf"
        ? _c("span", [_vm._v(_vm._s(_vm.$t("pf")))])
        : _vm._e(),
      _vm.profile.billing_type == "pj"
        ? _c("span", [_vm._v(_vm._s(_vm.$t("pj")))])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "profile-name" }, [
      _vm._v(" " + _vm._s(_vm.profile.name) + " "),
    ]),
    _c("div", { staticClass: "row address" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "fiscal-or-address" }, [
          _vm._v(
            " " +
              _vm._s(_vm.profile.fiscal_or_address) +
              ", " +
              _vm._s(_vm.profile.country_name) +
              " "
          ),
        ]),
        !_vm.isValidatedProfile(_vm.profile)
          ? _c("div", { staticClass: "text-warning" }, [
              _vm._v(" " + _vm._s(_vm.$t("profiles_unverified_data")) + " "),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm.profile.has_instant_credit || _vm.profile.has_instant_credit_tpf
      ? _c(
          "div",
          { staticClass: "instant-credit" },
          [
            _c("br"),
            _vm.profile.has_instant_credit &&
            _vm.profile.instant_limit_amount > 0
              ? [
                  _c("div", { staticClass: "amount" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("payment_method_credit_erv")) +
                        ": " +
                        _vm._s(_vm.profile.instant_limit_amount.toFixed(2)) +
                        " " +
                        _vm._s(
                          _vm.$tc("currency", _vm.profile.instant_limit_amount)
                        ) +
                        " "
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm.profile.has_instant_credit_tpf &&
            _vm.profile.instant_limit_tpf_amount > 0
              ? [
                  _c("div", { staticClass: "amount" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("payment_method_credit_tpf")) +
                        ": " +
                        _vm._s(
                          _vm.profile.instant_limit_tpf_amount.toFixed(2)
                        ) +
                        " " +
                        _vm._s(
                          _vm.$tc(
                            "currency",
                            _vm.profile.instant_limit_tpf_amount
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm.profile.has_instant_debit || _vm.profile.has_instant_debit_tpf
      ? _c(
          "div",
          { staticClass: "instant-debit" },
          [
            _c("br"),
            _vm.profile.has_instant_debit &&
            _vm.profile.instant_debit_limit_amount > 0
              ? [
                  _c("div", { staticClass: "amount" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("payment_method_debit_erv")) +
                        ": " +
                        _vm._s(
                          _vm.profile.instant_debit_limit_amount.toFixed(2)
                        ) +
                        " " +
                        _vm._s(
                          _vm.$tc(
                            "currency",
                            _vm.profile.instant_debit_limit_amount
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm.profile.has_instant_debit_tpf &&
            _vm.profile.instant_debit_limit_tpf_amount > 0
              ? [
                  _c("div", { staticClass: "amount" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("payment_method_debit_tpf")) +
                        ": " +
                        _vm._s(
                          _vm.profile.instant_debit_limit_tpf_amount.toFixed(2)
                        ) +
                        " " +
                        _vm._s(
                          _vm.$tc(
                            "currency",
                            _vm.profile.instant_debit_limit_tpf_amount
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }